import React, { createContext, useState, ReactNode } from "react";
import { ITableContext } from "./Utils/Interfaces/ITableContext";
import { IFilterOption } from "./Utils/Interfaces/IFilter";
import { setFromTable } from "../../redux/slice/filterSlice";
import { batch } from "react-redux";
import { fetchBookings } from "../../redux/slice/bookingSlice";
import { useAppDispatch } from "../../redux/dispatch/useAppDispatch";

interface ITableContextValue {
  tableContext: ITableContext;
  updateFilters: (filters: IFilterOption[]) => void;
}

const TableContext = createContext<ITableContextValue | undefined>(undefined);

// 2. Context Provider'ı oluşturun
interface TableContextProviderProps {
  children: ReactNode;
}

const initialTableContext: ITableContext = {
  filters: null,
};

export const TableContextWrapper: React.FC<TableContextProviderProps> = ({
  children,
}) => {
  const [tableContext, setTableContext] = useState(initialTableContext);
  const dispatch = useAppDispatch();
  const updateFilters = async (filters: IFilterOption[]) => {
    batch(() => {
      dispatch(setFromTable(filters));

      dispatch(fetchBookings({page : 1}));

      setTableContext((prevData) => ({
        ...prevData,
        filters: filters,
      }));
    });
  };

  const contextValue: ITableContextValue = {
    tableContext,
    updateFilters,
  };

  return (
    <TableContext.Provider value={contextValue}>
      {children}
    </TableContext.Provider>
  );
};

export default TableContext;
